<div class="gap-[40px] flex flex-col shrink-0 font-['Archivo'] justify-start items-center px-6 py-10 bg-[#F2F5F7] w-full h-screen overflow-hidden relative" [@pageLoad]="pageLoadState">
    <!-- Header -->
    <div class="flex flex-row w-full justify-between gap-6 items-start pl-10 pr-[58px]">
        <div class="flex flex-col items-start justify-start gap-3 max-w-[420px]">
            <button
                type="button"
                class="inline-flex items-center gap-[8px] h-[36px] px-[10px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
                (click)="goBack()"
                [attr.aria-label]="backLabel">
                <svg class="w-[16px] h-[16px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{{ backLabel }}</span>
            </button>
            <span class="shrink-0 justify-start items-start text-[#111215] text-left font-bold font-['Archivo'] text-2xl leading-8">
                {{ lunchTitle }}
            </span>
            <span class="text-[#667085] text-left font-normal font-['Archivo'] text-[14px] leading-5">
                {{ deliveryHint }}
            </span>
        </div>
        <div class="gap-6 flex flex-row justify-end items-end">
            <div class="flex flex-col justify-center items-center w-[400px]">
                <NiTextField 
                    class="flex-col justify-center items-center w-[400px] h-[40px]"
                    [placeholder]="searchPlaceholder"
                    [required]="false"
                    [disabled]="false"
                    [readonly]="false"
                    [leftIcon]="'search_lg'"
                    [label]="''"
                    [value]="searchValue"
                    [height]="40"
                    [borderRadius]="8"
                    [border]="'1'"
                    [padding]="{ top: 8, bottom: 8, left: 34, right: 34 }"
                    customInputClasses="text-[16px] h-[40px] w-[400px] rounded-[8px] font-[Archivo] border-[#D0D1D4]"
                    (valueChange)="onSearchChange($event)"
                ></NiTextField>
            </div>
            <div class="gap-2 flex flex-row shrink-0 rounded-lg justify-start items-center bg-[#F3F5F8] relative z-20">
                <NiButton 
                    *ngFor="let statusConfig of statusConfigs; trackBy: trackByStatusKey"
                    type="button"
                    [label]="statusConfig.label"
                    [bg]="getStatusButtonConfig(statusConfig.key).bg"
                    [textColor]="getStatusButtonConfig(statusConfig.key).textColor"
                    [borderColor]="getStatusButtonConfig(statusConfig.key).borderColor"
                    [border]="'1'"
                    hoverBg="white"
                    [px]="'3'"
                    [py]="'2'"
                    rounded="[4px]"
                    fontSize="[14px]"
                    fontWeight="normal"
                    [badge]="statusConfig.showBadge ? getStatusCount(statusConfig.key).toString() : ''"
                    [batchColur]="statusConfig.showBadge ? (getStatusButtonConfig(statusConfig.key).badgeColor || '') : ''"
                    badgeClass="text-white"
                    (onClick)="onStatusChange(statusConfig.key)"
                    styleClass="relative transition-all duration-300 ease-out font-['Archivo'] cursor-pointer"
                ></NiButton>
            </div>
        </div>
    </div>
    
    <!-- Main Content -->
    <div class="flex flex-row w-full shrink-0 justify-start items-start self-stretch relative gap-2">
        <!-- Skeleton Loader -->
        <div *ngIf="isLoading" class="flex flex-col w-full shrink-0 justify-center items-center grow basis-0 min-h-[calc(100vh-280px)]">
            <div class="gap-4 flex flex-col shrink-0 justify-center items-center">
                <div class="skeleton-item" *ngFor="let item of [1, 2, 3]">
                    <div class="skeleton-circle"></div>
                    <div class="skeleton-lines">
                        <div class="skeleton-line"></div>
                        <div class="skeleton-line"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Actual Content -->
        <div *ngIf="!isLoading" 
             #contentContainer
             class="participants-content-container gap-10 flex flex-col w-full shrink-0 justify-start items-start grow basis-0 pr-2 overflow-y-auto overflow-x-hidden"
             (scroll)="updateActiveLetter()">
            <!-- No Data State -->
            <div *ngIf="hasNoData" 
                 @noDataAnimation
                 class="no-data-container flex flex-col w-full items-center justify-center min-h-[400px] gap-4">
                <div class="no-data-icon flex items-center justify-center w-24 h-24 rounded-full bg-[#F2F5F7] mb-2">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-[#94A3B8]">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
                    </svg>
                </div>
                <div class="flex flex-col items-center justify-center gap-2">
                    <p class="text-[#64748B] text-center font-normal font-['Archivo'] text-base leading-6 max-w-lg">
                        {{ getEmptyStateMessage() }}
                    </p>
                </div>
            </div>
            
            <!-- Participants List -->
            <ng-container *ngIf="!hasNoData">
                <ng-container *ngIf="selectedStatus !== 'waiting-list'; else waitingListView">
                    <div *ngFor="let group of groupedParticipants; trackBy: trackByLetter" 
                         [id]="'letter-' + group.letter"
                         class="letter-group gap-5 flex flex-row w-full shrink-0 justify-start items-start self-stretch scroll-mt-2">
                        <span class="w-5 shrink-0 justify-start items-start text-[#111215] text-center font-bold font-['Open_Sans'] text-xl leading-7 opacity-50">
                            {{ group.letter }}
                        </span>
                        <div class="gap-5 flex flex-row w-full content-center flex-wrap shrink-0 justify-start items-start grow basis-0">
                            <div *ngFor="let participant of group.participants; trackBy: trackByParticipant; let i = index"
                                 class="participant-card-wrapper"
                                 [style.animation-delay]="(i * 0.05) + 's'">
                                <app-participant-card
                                    [participant]="participant"
                                    [isSelected]="isParticipantSelected(participant.id)"
                                    (cardClick)="onParticipantClick($event)">
                                </app-participant-card>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #waitingListView>
                    <div class="gap-5 ps-10 flex flex-row w-full content-center flex-wrap shrink-0 justify-start items-start grow basis-0">
                        <div *ngFor="let participant of waitingListParticipants; trackBy: trackByParticipant; let i = index"
                             class="participant-card-wrapper"
                             [style.animation-delay]="(i * 0.05) + 's'">
                            <app-participant-card
                                [participant]="participant"
                                [isSelected]="isParticipantSelected(participant.id)"
                                (cardClick)="onParticipantClick($event)">
                            </app-participant-card>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </div>
        
        <!-- Alphabetical Navigation -->
        <div *ngIf="(!isLoading && selectedStatus !== 'waiting-list')" class="alphabet-nav flex flex-col shrink-0 rounded justify-start items-center bg-white sticky top-10 max-h-[calc(100vh-200px)] overflow-y-auto overflow-x-hidden ml-2">
            <button *ngFor="let letter of alphabet"
                 type="button"
                 class="alphabet-item flex flex-col w-[32px] h-[32px] shrink-0 rounded-[4px] justify-center items-center cursor-pointer transition-all duration-200"
                 [ngClass]="{
                   'active h-7': isLetterActive(letter),
                   'h-6 bg-white hover:bg-gray-100': !isLetterActive(letter),
                   'opacity-50 pointer-events-none': !availableLetters.includes(letter)
                 }"
                 (click)="scrollToLetter(letter)"
                 (keydown)="handleAlphabetKeyDown($event, letter)"
                 [attr.aria-label]="'Scroll to letter ' + letter"
                 [disabled]="!availableLetters.includes(letter)">
                <span class="w-full text-[#231F20] text-center font-semibold font-['Archivo'] text-[16px] leading-4">
                    {{ letter }}
                </span>
            </button>
        </div>
    </div>
</div>

<!-- Delivered vs Not present confirmation -->
<div
  *ngIf="pendingDeliveryParticipant"
  class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="deliveryConfirmTitle"
  (click)="closeDeliveryActionModal()">
  <div
    class="w-full max-w-[420px] rounded-[16px] bg-white p-6 shadow-[0_20px_40px_rgba(17,18,21,0.18)]"
    (click)="$event.stopPropagation()">
    <h2 class="m-0 text-center font-['Archivo'] text-[20px] font-bold leading-[28px] text-[#111215]">
      {{ deliveryConfirmTitle }}
    </h2>
    <p class="mt-2 mb-0 text-center font-['Archivo'] text-[16px] leading-[24px] text-[#667085]">
      {{ deliveryConfirmBody }}
    </p>
    <div class="mt-6 flex flex-col gap-3">
      <button
        type="button"
        class="flex min-h-[48px] w-full items-center justify-center rounded-[999px] border-0 bg-[#40AB35] px-5 font-['Archivo'] text-[16px] font-semibold text-white"
        (click)="confirmMarkDelivered()">
        {{ markDeliveredLabel }}
      </button>
      <button
        type="button"
        class="flex min-h-[48px] w-full items-center justify-center rounded-[999px] border border-[#B42318] bg-white px-5 font-['Archivo'] text-[16px] font-semibold text-[#B42318]"
        (click)="confirmMarkNotPresent()">
        {{ markNotPresentLabel }}
      </button>
      <button
        type="button"
        class="flex min-h-[44px] w-full items-center justify-center rounded-[999px] border-0 bg-transparent px-5 font-['Archivo'] text-[15px] font-semibold text-[#667085]"
        (click)="closeDeliveryActionModal()">
        {{ cancelDeliveryActionLabel }}
      </button>
    </div>
  </div>
</div>

<div
  *ngIf="deliveryToast"
  class="fixed bottom-8 left-1/2 z-50 flex min-w-[320px] -translate-x-1/2 items-center justify-center gap-4 rounded-[12px] px-[20px] py-[14px] text-center transition-all duration-300 ease-out opacity-100 translate-y-0 scale-100 max-sm:left-4 max-sm:right-4 max-sm:bottom-4 max-sm:translate-x-0 max-sm:flex-col max-sm:rounded-2xl"
  [ngClass]="{
    'opacity-0 translate-y-3 scale-[0.98] pointer-events-none': deliveryToast.isHiding,
    'border border-[#A8E0B1] bg-[#ECF7EB] text-[#1F7A34] shadow-[0px_18px_35px_rgba(58,122,62,0.18)]': deliveryToast.outcome !== 'not_delivered',
    'border border-[#FECDCA] bg-[#FEF3F2] text-[#B42318] shadow-[0px_18px_35px_rgba(180,35,24,0.14)]': deliveryToast.outcome === 'not_delivered'
  }"
  aria-live="assertive"
  [attr.aria-busy]="deliveryToast.isUndoing">
  <div class="flex items-center gap-3 font-['Archivo'] max-sm:justify-center">
    <div class="flex h-10 w-10 items-center justify-center rounded-[8px]" aria-hidden="true">
      <svg *ngIf="deliveryToast.outcome !== 'not_delivered'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="#2AA345" stroke-width="2"/>
        <path d="M6 10.5L8.5 13L14 7" stroke="#2AA345" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg *ngIf="deliveryToast.outcome === 'not_delivered'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="#B42318" stroke-width="2"/>
        <path d="M7 7L13 13M13 7L7 13" stroke="#B42318" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="flex flex-col leading-tight">
      <span class="text-base font-semibold">{{ deliveryToast.message }}</span>
    </div>
    <!-- Spinner with Countdown -->
    <div *ngIf="!deliveryToast.isUndoing" class="relative flex items-center justify-center ml-2">
      <div
        class="toast-spinner w-8 h-8 border-2 border-t-transparent rounded-full"
        [ngClass]="deliveryToast.outcome === 'not_delivered' ? 'border-[#B42318]' : 'border-[#2AA345]'"></div>
      <span
        class="absolute text-xs font-semibold"
        [ngClass]="deliveryToast.outcome === 'not_delivered' ? 'text-[#B42318]' : 'text-[#1F7A34]'">{{ deliveryToast.remainingSeconds }}</span>
    </div>
  </div>
  <div class="flex items-center gap-3 max-sm:w-full max-sm:flex-col">
    <button
      type="button"
      class="rounded-[8px] border bg-white px-[16px] py-[6px] font-['Archivo'] text-[15px] font-semibold shadow-sm transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60 max-sm:w-full"
      [ngClass]="deliveryToast.outcome === 'not_delivered'
        ? 'border-[#FECDCA] text-[#B42318] hover:bg-[#FFF5F5]'
        : 'border-[#D2EED6] text-[#308028] hover:bg-[#F6FFF7]'"
      (click)="handleDeliveryUndo()"
      [disabled]="deliveryToast.isUndoing">
      {{ deliveryToast.isUndoing ? 'Undoing...' : 'Undo' }}
    </button>
    <button
      type="button"
      class="flex h-10 w-10 items-center justify-center rounded-full border border-transparent transition hover:bg-white"
      [ngClass]="deliveryToast.outcome === 'not_delivered'
        ? 'text-[#B42318] hover:border-[#FECDCA]'
        : 'text-[#347744] hover:border-[#D2EED6]'"
      (click)="dismissDeliveryToast()"
      aria-label="Dismiss delivery message">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>
</div>
